import {createSelector} from "reselect";
import {getArticleOptionCollections, getBaseArticle} from "./SimpleSelectors";
import {getArticleOptionsInCartList, getArticleOptionsInCartObject} from "./CartUtil";
import {agencyServerProjectArticles, cmsArticles, shopArticles} from "../config/Config";

export const getAgencyServerProjectArticlesInCartSplit = createSelector(
    [getArticleOptionsInCartObject, getArticleOptionCollections],
    (
        articleOptionsInCart,
        articleOptionCollections
    ) => {

        let matches = {
            storage: [],
            article: []
        }

        articleOptionsInCart.forEach(item => {
            if (agencyServerProjectArticles.indexOf("" + item.articleNumber) >= 0) {

                matches.article.push(item);
                // article found, check if matching storage items are in cart
                if (
                    articleOptionCollections["" + item.articleNumber].hardware
                    && articleOptionCollections["" + item.articleNumber].hardware.hddSw
                ) {
                    const collection = articleOptionCollections["" + item.articleNumber].hardware.hddSw

                    articleOptionsInCart.forEach(swItem => {

                        if (collection.indexOf(swItem.articleNumber) >= 0) {
                            matches.storage.push(swItem)
                        }

                    });
                }

            }
        });
        return matches;
    }
)

export const getAgencyServerProjectArticlesInCart = createSelector(
    getAgencyServerProjectArticlesInCartSplit,
    (
        projectsInCartSplit
    ) => {
        return [...projectsInCartSplit.storage, ...projectsInCartSplit.article];
    }
)

export const getConsumerArticlesInCartSplit = createSelector(
    [getArticleOptionsInCartObject, getArticleOptionCollections, getBaseArticle],
    (
        articleOptionsInCart,
        articleOptionCollections,
        baseArticleData
    ) => {

        let matches = {
            storage: [],
            article: []
        }

        const articlesToCheck = [...articleOptionsInCart, baseArticleData];

        articlesToCheck.forEach(item => {
            if (
                cmsArticles.indexOf("" + item.articleNumber) >= 0
                || shopArticles.indexOf("" + item.articleNumber) >= 0
            ) {
                matches.article.push(item);
                // article found, check if matching storage items are in cart
                if (
                    articleOptionCollections["" + item.articleNumber].hardware
                    && articleOptionCollections["" + item.articleNumber].hardware.hddSw
                ) {
                    const collection = articleOptionCollections["" + item.articleNumber].hardware.hddSw

                    articleOptionsInCart.forEach(swItem => {

                        if (collection.indexOf(swItem.articleNumber) >= 0) {
                            matches.storage.push(swItem)
                        }

                    });
                }

            }
        });
        return matches;
    }
)

export const isProjectSelected = createSelector(
    getBaseArticle,
    getArticleOptionsInCartList,
    (baseArticle, articleOptionsInCart) => {
        return articleOptionsInCart.some(item => {
            if (agencyServerProjectArticles.indexOf("" + item) >= 0) {
                return true
            } else {
                return false
            }
        });
    }
)


/** WEBPACK FOOTER **
 ** ./src/selectors/ProjectSelection.js
 **/